export const PRICING_STRATEGIES = {
  basePrice: 'BASE_PRICE',
  mktPrice: 'MKT_PRICE',
  timeBasedPrice: 'TIME_SPECIFIC_PRICE',
  categoryPrice: 'CATEGORY_PRICE',
}

export const PRICING_ESTRATEGIES_TRANSLATIONS = {
  en: {
    [PRICING_STRATEGIES.basePrice]: 'Base Price',
    [PRICING_STRATEGIES.mktPrice]: 'Market Price',
    [PRICING_STRATEGIES.timeBasedPrice]: 'Time-Based Price'
  }, 
  es: {
    [PRICING_STRATEGIES.basePrice]: 'Precio Base',
    [PRICING_STRATEGIES.mktPrice]: 'Precio en el Mercado',
    [PRICING_STRATEGIES.timeBasedPrice]: 'Precio Basado en Tiempo',
  },
}
